export const importExportEn = {
  import: {
    // Steps
    stepUpload: 'Upload',
    stepMapping: 'Field Mapping',
    stepPreview: 'Preview',
    stepResult: 'Result',

    // Upload step
    title: 'Import {entity}',
    dropHere: 'Drop the file here or click to browse',
    supportedFormats: 'Supported formats: CSV, XLSX, XLS, ODS',
    noTemplate: "Don't know which format to use?",
    downloadTemplate: 'Download template',
    emptyFile: 'The file contains no data',
    parseError: 'Error reading file',

    // Mapping step
    file: 'File',
    rows: 'rows',
    targetField: 'Target field',
    sourceColumn: 'Source column',
    required: 'Required',
    noMapping: '— No mapping —',
    back: 'Back',
    next: 'Preview',

    // Preview step
    validRows: 'Valid rows',
    errorRows: 'Invalid rows',
    totalRows: 'Total rows',
    errors: 'Errors',
    showingFirst: 'Showing: first 10 of {count} valid rows',
    importRows: 'Import {count} rows',
    noValidRows: 'No valid rows to import',

    // Importing step
    importing: 'Importing...',
    importingWait: 'Please wait while records are being processed',

    // Result step
    success: 'Import successful!',
    completed: 'Import completed',
    resultSummary: '{success} successful, {failed} failed',
    close: 'Close',

    // Export
    export: 'Export',
    exportCSV: 'CSV format',
    exportExcel: 'Excel (XLSX)',
    noData: 'No data to export',
    exportSuccess: '{count} records exported ({format})',
    exportError: 'Error during export',

    // Import results
    importSuccess: '{count} records successfully imported',
    importFailed: '{count} records failed to import',
    importError: 'Error during import',

    // Entity names
    customers: 'Customers',
    suppliers: 'Suppliers',
    products: 'Products',

    // Button labels with entity
    importButton: '{entity} Import',
    exportButton: '{entity} Export',
  },
};
